(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glown-community"] && !Shopify.designMode) return;
  try {
    function bindGlownStories(scope) {
    scope.querySelectorAll('.glown-community').forEach(gallery => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      const dialog = gallery.querySelector('dialog');
      const full = dialog.querySelector('.glown-community-full');
      let opener;
      gallery.querySelectorAll('[data-glown-story]').forEach(button => {
        button.addEventListener('click', () => {
          opener = button;
          full.src = button.dataset.glownStory;
          full.alt = button.querySelector('img').alt;
          dialog.showModal();
        });
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { if (opener) opener.focus(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindGlownStories(document));
  else bindGlownStories(document);
  document.addEventListener('shopify:section:load', event => bindGlownStories(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glown-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glown-product-gallery')) {
    customElements.define('glown-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const stage = this.querySelector('.glown-pg-stage');
        const slides = [...this.querySelectorAll('.glown-pg-slide')];
        const thumbs = [...this.querySelectorAll('[data-index]')];
        let current = 0;
        let scrollTimer;
        const update = index => {
          current = Math.max(0, Math.min(index, slides.length - 1));
          thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        };
        const go = index => {
          const next = (index + slides.length) % slides.length;
          update(next);
          stage.scrollTo({ left: stage.clientWidth * next, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => go(i)));
        stage.addEventListener('click', () => go(current + 1));
        stage.addEventListener('scroll', () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => update(Math.round(stage.scrollLeft / stage.clientWidth)), 140);
        }, { passive: true });
        stage.addEventListener('keydown', event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          go(current + (event.key === 'ArrowRight' ? 1 : -1));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
